export const BU = 5
export const APPLICATION = 'mobile'
export const SUB_APPLICATION = 'standalone'

export const CATEGORY_TYPE_PRODUCT_LIST_NAV = 'PRODUCT-LIST-NAV'

export const TYPE_CATEGORY = 'category'
export const TYPE_PRODUCT = 'product'